import React from 'react';
import { Link } from 'react-scroll';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Services from './components/Services';
import Solutions from './components/Solutions';
import About from './components/About';
import Contact from './components/Contact';
import Footer from './components/Footer';
import './App.css';

function App() {
  return (
    <div className="App">
      <Navbar />
      <Link to="home" smooth={true} duration={500} className="site-logo">
        <img src="/Images/victorcharles icon logo.png" alt="Victor Charles Logo" className="site-logo-icon" />
      </Link>
      <Hero />
      <Services />
      <Solutions />
      <About />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;

